<template>
  <section v-if="visible" class="onboarding-checklist" aria-label="Getting started">
    <header class="flex items-center justify-between">
      <h2 class="font-semibold">Getting started ({{ completedCount }}/{{ total }})</h2>
      <button type="button" class="text-sm underline" @click="dismiss">Dismiss</button>
    </header>
    <ul>
      <li v-for="step in steps" :key="step.key" class="flex items-center justify-between py-1">
        <span :class="step.done ? 'line-through opacity-60' : ''">
          <span aria-hidden="true">{{ step.done ? "✓" : "○" }}</span> {{ step.label }}
        </span>
        <router-link v-if="!step.done" :to="{ name: step.routeName }" class="text-sm underline">
          {{ step.ctaLabel }}
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script lang="ts">
import { defineComponent, onMounted } from "vue";
import useOnboarding from "/@/composables/useOnboarding";

export default defineComponent({
  name: "OnboardingChecklist",
  setup() {
    const { steps, visible, completedCount, total, dismiss, refresh } = useOnboarding();
    onMounted(refresh);
    return { steps, visible, completedCount, total, dismiss };
  },
});
</script>

<style lang="postcss" scoped></style>
